// Card spotlight — pomelo.la-style cursor glow. On pointer move over any
// [data-spotlight] card we write the pointer position into --mx/--my (in %),
// and the SCSS paints a soft radial highlight at that point (visible on hover).
// Opt-in via the attribute so it can be reused beyond beneficios (sector cards,
// future grids). Event delegation on document so Owl carousel clones work too.
// Skips touch + reduced-motion so it never fights mobile or accessibility prefs.
document.addEventListener('DOMContentLoaded', function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return
  if (window.matchMedia('(hover: none)').matches) return

  document.addEventListener(
    'pointermove',
    function (e) {
      const card = e.target.closest && e.target.closest('[data-spotlight]')
      if (!card) return
      const r = card.getBoundingClientRect()
      card.style.setProperty('--mx', ((e.clientX - r.left) / r.width) * 100 + '%')
      card.style.setProperty('--my', ((e.clientY - r.top) / r.height) * 100 + '%')
    },
    { passive: true }
  )
})
